import React, { useState } from 'react';

const ClientDetailsSection = ({ client, onClose, onUpdateClient, canEdit }) => { // Recibir canEdit
  const [formData, setFormData] = useState({
    email: client.email || '',
    country: client.country || 'México',
    salesExecutive: client.salesExecutive || '',
    googleAdsLink: client.googleAdsLink || '',
    googleMapsLink: client.googleMapsLink || '',
    facebookLink: client.facebookLink || '',
    metaAccountLink: client.metaAccountLink || ''
  });
  const [isEditing, setIsEditing] = useState(false);

  const countries = [
    'México', 'Estados Unidos', 'Canadá', 'España', 'Colombia', 'Perú', 'Ecuador', 'Panamá',
    'República Dominicana', 'El Salvador', 'Chile', 'Honduras', 'Guatemala', 'Belice', 'Paraguay',
    'Uruguay', 'Bolivia'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onUpdateClient({ ...client, ...formData });
    setIsEditing(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-bold text-[#0061A8]">Datos del Cliente: {client.name}</h2>
            <button 
              onClick={onClose}
              className="text-[#63666A] hover:text-[#0061A8]"
            >
              ✕
            </button>
          </div>

          <div className="space-y-4 text-sm text-[#63666A]">
            {isEditing ? (
              <>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">Email</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} 
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">País</label>
                  <select name="country" value={formData.country} onChange={handleChange}
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]">
                    {countries.map(country => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">Ejecutivo de Ventas</label>
                  <input type="text" name="salesExecutive" value={formData.salesExecutive} onChange={handleChange} 
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">Link Google Ads</label>
                  <input type="url" name="googleAdsLink" value={formData.googleAdsLink} onChange={handleChange} 
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">Link Google Maps</label>
                  <input type="url" name="googleMapsLink" value={formData.googleMapsLink} onChange={handleChange} 
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">Link Facebook</label>
                  <input type="url" name="facebookLink" value={formData.facebookLink} onChange={handleChange} 
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#63666A]">Link Cuenta de Meta</label>
                  <input type="url" name="metaAccountLink" value={formData.metaAccountLink} onChange={handleChange} 
                    className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]" />
                </div>
                <div className="flex justify-end space-x-3 mt-4">
                  <button
                    type="button"
                    onClick={() => setIsEditing(false)}
                    className="border border-[#D1D3D4] text-[#63666A] py-2 px-4 rounded-md hover:bg-opacity-80 transition-colors"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    onClick={handleSave}
                    className="bg-[#0061A8] text-[#FFFFFF] py-2 px-4 rounded-md hover:bg-opacity-90 transition-colors"
                  >
                    Guardar Cambios
                  </button>
                </div>
              </>
            ) : (
              <>
                <p><span className="font-medium">Email:</span> {client.email || 'N/A'}</p>
                <p><span className="font-medium">País:</span> {client.country || 'N/A'}</p>
                <p><span className="font-medium">Ejecutivo de Ventas:</span> {client.salesExecutive || 'N/A'}</p>
                
                {client.googleMapsLink && (
                  <p>
                    <span className="font-medium">Google Maps:</span>{' '}
                    <a href={client.googleMapsLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                      Ver Ubicación
                    </a>
                  </p>
                )}
                {client.googleAdsLink && (
                  <p>
                    <span className="font-medium">Google Ads:</span>{' '}
                    <a href={client.googleAdsLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                      Ver Cuenta
                    </a>
                  </p>
                )}
                {client.facebookLink && (
                  <p>
                    <span className="font-medium">Facebook:</span>{' '}
                    <a href={client.facebookLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                      Ver Página
                    </a>
                  </p>
                )}
                {client.metaAccountLink && (
                  <p>
                    <span className="font-medium">Cuenta de Meta:</span>{' '}
                    <a href={client.metaAccountLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                      Ver Cuenta
                    </a>
                  </p>
                )}
                {canEdit && ( // Solo si tiene permiso de edición
                  <div className="flex justify-end mt-4">
                    <button
                      type="button"
                      onClick={() => setIsEditing(true)}
                      className="bg-[#A8D08D] text-[#FFFFFF] py-2 px-4 rounded-md hover:bg-opacity-90 transition-colors text-sm"
                    >
                      Editar Datos
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsSection;